import { TFunction } from 'i18next';
import { z } from 'zod';

import {
  AccountStatus,
  PaymentMethod,
} from '@bvi/api-interfaces/entity/client';

export const buildValidationSchema = (t: TFunction) => {
  const dateValue = z
    .number({
      invalid_type_error: t('error.form.required'),
      required_error: t('error.form.required'),
    })
    .or(z.date());

  return z
    .object({
      subscriptionStartsAt: dateValue,
      subscriptionExpiresAt: dateValue,
      subscriptionTermMonths: z.coerce
        .number({
          invalid_type_error: t('error.form.required'),
          required_error: t('error.form.required'),
        })
        .int()
        .min(1, t('error.form.required')),
      accountStatus: z.nativeEnum(AccountStatus, {
        required_error: t('error.form.required'),
        invalid_type_error: t('error.form.required'),
      }),
      paymentMethod: z.nativeEnum(PaymentMethod).optional().nullable(),
      paymentMethodNotes: z.string().optional().nullable(),
      accountManagerName: z.string().optional().nullable(),
      accountManagerEmail: z
        .string()
        .email(t('error.form.email'))
        .or(z.literal(''))
        .optional()
        .nullable(),
      supportLiaisonName: z.string().optional().nullable(),
      supportLiaisonEmail: z
        .string()
        .email(t('error.form.email'))
        .or(z.literal(''))
        .optional()
        .nullable(),
      pricingNarrative: z.string().optional().nullable(),
      orientationAt: z.union([z.number(), z.date()]).optional().nullable(),
    })
    .refine(
      (values) =>
        new Date(values.subscriptionStartsAt).getTime() <=
        new Date(values.subscriptionExpiresAt).getTime(),
      {
        message: t('error.form.startBeforeEnd'),
        path: ['subscriptionExpiresAt'],
      },
    )
    .refine(
      (values) =>
        values.paymentMethod !== PaymentMethod.Other ||
        Boolean(values.paymentMethodNotes?.trim()),
      {
        message: t('error.form.required'),
        path: ['paymentMethodNotes'],
      },
    );
};
